import Vuex, { ActionTree } from 'vuex';

import company, { CompanyState } from './company';
import config, { ConfigState } from './config';
import dailyReport, { DailyReportState } from './dailyReport';
import location, { LocationState } from './location';
import report, { ReportState } from './report';
import user, { UserState } from './user';


export interface RootState {
  company: CompanyState;
  config: ConfigState;
  dailyReport: DailyReportState;
  location: LocationState;
  report: ReportState;
  user: UserState;
}


export interface RootActions {
  loadDefault: () => Promise<any>;
  reset: () => Promise<any>;
  setLocation: (locationId: number) => Promise<any>;
}

const actions: ActionTree<RootState, RootState> = {
  /**
   * Clear everything from stores. Called on logout.
   */
  reset(store) {
    store.commit('company/reset');
    store.commit('config/reset');
    store.commit('dailyReport/reset');
    store.commit('location/reset');
    store.commit('report/reset');
    store.commit('user/reset');
  },

  /**
   * Load everything on startup.
   */
  async loadDefault(store) {
    await Promise.all([
      store.dispatch('config/fetch'),
      store.dispatch('company/fetch'),
    ]);

    await store.dispatch('location/loadDefault');

    await Promise.all([
      store.dispatch('dailyReport/fetch'),
      store.dispatch('report/fetchRoot'),
    ]);
  },

  /**
   * Change application context (selected location).
   */
  setLocation(store, locationId: string) {
    store.dispatch('location/setById', locationId);
    store.dispatch('dailyReport/fetch');
    store.dispatch('report/fetchRoot');
  },
};



export default new Vuex.Store<RootState>({
  actions,
  modules: {
    company,
    config,
    dailyReport,
    location,
    report,
    user,
  },
});


// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace RootStore {
  export type Action <TProp extends keyof RootActions> = RootActions[TProp];
}
